import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ChangeDetectorRef,
  AfterContentChecked,
  OnDestroy,
} from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { VentaService } from 'src/app/modules/venta';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationService } from 'src/app/core';
import { MyCurrencyPipe } from '../../pipes/myCurrency.pipe';
import { TranslateService } from '../../services/translate.service';
import { Subscription } from 'rxjs';
import { DivisaObject } from '../../interfaces/global.interface';
import { SinpeService } from '../../services/sinpe.service';

@Component({
  selector: 'ticketing-calcular-sinpe',
  templateUrl: './calcular-sinpe.component.html',
  styleUrls: ['./calcular-sinpe.component.scss'],
})
export class CalcularSinpeComponent implements OnInit, AfterContentChecked {
  @Input() id: string;
  private element: HTMLElement;

  data: number | null = null;
  cambio: number = 0;
  isOpen = false;
  operacionesEncontradas: Array<any> = [];
  tipoCedula: string = '';
  numDocumento: string = '';
  mensajeError: string = '';
  sinpesSeleccionados: { codReferencia: string; monto: number }[] = [];
  totalPagar: number = 0;
  totalPagarFormateado: string = '';
  tipoIdentificacionSINPE = {
    options: [] as { value: string; nombre: string }[],
  };
  importe: string = '';
  placeholderValue: string = '';
  divisaSimboloDecimal: string = '';
  divisaSimbSeparacionMiles: string = '';
  divisaSimbolo: string = '';
  divisaDecimales: number = 0;
  divisaPosicion: string = '';
  divisaSimboloDerecha: string = '';

  divisa: DivisaObject | null = null;
  subscription: Subscription = new Subscription();
  configSub: Subscription = new Subscription();
  sinpeForm!: FormGroup;
  operaciones: Array<{
    codReferencia: string;
    monto: number;
    seleccionada?: boolean;
  }> = [];
  seleccionPrevia: { codReferencia: string; monto: number }[] = [];

  constructor(
    private modalService: ModalService,
    private ventaService: VentaService,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private myCurrencyPipe: MyCurrencyPipe,
    private configuration: ConfigurationService,
    private translate: TranslateService,
    private sinpeService: SinpeService,
    private el: ElementRef
  ) {
    this.element = this.el.nativeElement;
  }

  ngOnInit() {
    if (!this.id) return;

    // Añadir modal al body para evitar problemas de encapsulación de estilos
    document.body.appendChild(this.element);

    this.element.addEventListener('click', (e: MouseEvent) => {
      if ((e.target as HTMLElement).classList.contains('jw-modal')) {
        this.close();
      }
    });

    this.modalService.add(this);

    // Crear formulario con validaciones
    this.sinpeForm = this.formBuilder.group({
      tipoCedula: ['', Validators.required],
      numDocumento: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9-]+$'), // Letras, números y guiones permitidos
        ]),
      ],
    });

    // Suscripción a cambios de divisa para actualizar formato y símbolos
    this.subscription.add(
      this.configuration.divisas.subscribe((divisa) => {
        if (divisa && divisa.length > 0) {
          const div = divisa[0];
          this.divisaSimbSeparacionMiles = div.SimbSeparacionMiles;
          this.divisaSimboloDecimal = div.SimboloDecimal;
          this.divisaDecimales = Number(div.NumeroDecimales);
          this.divisaPosicion = div.PosicionDivisa;
          this.divisaSimbolo = div.simbolo;
          this.divisaSimboloDerecha = div.SimboloDerecha;
          this.placeholderValue = this.myCurrencyPipe.transform(
            0,
            this.divisaSimboloDecimal,
            this.divisaDecimales,
            this.divisaPosicion,
            this.divisaSimbolo,
            this.divisaSimboloDerecha,
            this.divisaSimbSeparacionMiles
          );
        }
      })
    );

    // Obtener datos iniciales para modal
    this.subscription.add(
      this.modalService.getData(this.id).subscribe((response) => {
        if (response !== undefined && response !== null) {
          this.data = Math.abs(response);
        }
      })
    );
    const test = this.sinpeService.getSeleccionadas();
    // Opciones por defecto para tipo de identificación SINPE
    this.tipoIdentificacionSINPE = {
      options: [
        { value: '1', nombre: 'Cedula Identidad' },
        { value: '4', nombre: 'Cedula Juridica' },
        { value: '7', nombre: 'Extranjero NoResidente' },
        { value: '8', nombre: 'DIMEX' },
        { value: '10', nombre: 'DIDI' },
      ],
    };

    // Cargar seleccion previa desde servicio
    this.subscription.add(
      this.sinpeService.seleccionadas$.subscribe((data) => {
        this.seleccionPrevia = data || [];
      })
    );

    this.setPrimerTipoIdentificacion();

    // Escuchar configuración remota para actualizar opciones de identificación
    this.configSub = this.configuration.appConfig.subscribe((data) => {
      if (
        data &&
        data.DatosResult &&
        data.DatosResult.AppConfigJsonConfig &&
        data.DatosResult.AppConfigJsonConfig.TipoIdentificacionSINPE
      ) {
        const nuevaConfig =
          data.DatosResult.AppConfigJsonConfig.TipoIdentificacionSINPE;

        const esDiferente =
          JSON.stringify(this.tipoIdentificacionSINPE) !==
          JSON.stringify(nuevaConfig);

        if (esDiferente) {
          this.tipoIdentificacionSINPE = nuevaConfig;
          this.setPrimerTipoIdentificacion();
        }
      }
    });
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  // ngOnDestroy(): void {
  //   // Evitar fugas de memoria limpiando suscripciones
  //   this.subscription.unsubscribe();
  //   this.configSub.unsubscribe();
  //   this.modalService.remove(this.);
  // }

  open(): void {
    this.element.style.display = 'block';
    document.body.classList.add('jw-modal-open');
    this.isOpen = true;
    this.onOpen();
  }

  private onOpen(): void {
    this.operacionesEncontradas = this.sinpeService.getOperaciones();
    this.sinpesSeleccionados = this.sinpeService.getSeleccionadas() || [];

    this.totalPagar = this.sinpesSeleccionados.reduce(
      (sum, p) => sum + p.monto,
      0
    );
    this.totalPagarFormateado = this.myCurrencyPipe.transform(
      this.totalPagar,
      this.divisaSimboloDecimal,
      this.divisaDecimales,
      this.divisaPosicion,
      this.divisaSimbolo,
      this.divisaSimboloDerecha,
      this.divisaSimbSeparacionMiles
    );

    const valores = this.sinpeService.obtenerValoresForm();
    if (valores) {
      this.sinpeForm.patchValue(valores);
    }
  }

  close(): void {
    // Resetear todos los datos para la próxima apertura
    this.data = null;
    this.cambio = 0;
    this.isOpen = false;
    this.operacionesEncontradas = [];
    this.tipoCedula = '';
    this.numDocumento = '';
    this.mensajeError = '';
    this.sinpesSeleccionados = [];
    this.totalPagar = 0;
    this.totalPagarFormateado = '';
    this.importe = '';
    this.sinpeForm.reset();
    this.setPrimerTipoIdentificacion();
    //this.sinpeService.resetearEstado();
    this.element.style.display = 'none';
    document.body.classList.remove('jw-modal-open');
  }


  private convertirFecha(fechaStr: string): string | null {
    if (!fechaStr) return null;

    // Corregir formato si viene sin guiones en la fecha
    const fechaCorregida = fechaStr.replace(
      /(\d{4})-(\d{2})(\d{2})T/,
      '$1-$2-$3T'
    );
    const fecha = new Date(fechaCorregida);

    if (isNaN(fecha.getTime())) return null;

    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const año = fecha.getFullYear();
    const horas = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');

    return `${dia}/${mes}/${año} ${horas}:${minutos}`;
  }

  private setPrimerTipoIdentificacion(): void {
    const opciones = this.tipoIdentificacionSINPE.options;
    if (opciones.length > 0) {
      const primerValor = opciones[0].value;
      const control = this.sinpeForm.get('tipoCedula');
      if (control && control.value !== primerValor) {
        control.setValue(primerValor, { emitEvent: false });
      }
    }
  }

  usarPago(pago: any) {
    if (!pago.utilizado) {
      this.sinpesSeleccionados.push({
        codReferencia: pago.codReferencia,
        monto: pago.monto,
      });
      this.totalPagar = parseFloat((this.totalPagar + pago.monto).toFixed(2));
    } else {
      this.sinpesSeleccionados = this.sinpesSeleccionados.filter(
        (s) => s.codReferencia !== pago.codReferencia
      );
      this.totalPagar = parseFloat((this.totalPagar - pago.monto).toFixed(2));
    }

    pago.utilizado = !pago.utilizado;

    // Actualizar formato visual del total a pagar
    this.totalPagarFormateado = this.myCurrencyPipe.transform(
      this.totalPagar,
      this.divisaSimboloDecimal,
      this.divisaDecimales,
      this.divisaPosicion,
      this.divisaSimbolo,
      this.divisaSimboloDerecha,
      this.divisaSimbSeparacionMiles
    );
  }

  consultarPago(): void {
    this.mensajeError = '';
    this.sinpesSeleccionados = [];
    this.totalPagar = 0;

    const { tipoCedula, numDocumento } = this.sinpeForm.value;

    this.ventaService.consultarPagoSINPE(tipoCedula, numDocumento).subscribe(
      (res: any) => {
        if (![1, 3, 7].includes(res.datosResult.codRespuesta)) {
          this.operacionesEncontradas = [];
          this.mensajeError =
            res.datosResult.descripcion || 'Error desconocido';
          return;
        }

        this.operacionesEncontradas = res.datosResult.pagos.map(
          (pago: any) => ({
            ...pago,
            fechaRecibido: this.convertirFecha(pago.fechaRecibido),
            utilizado: false,
          })
        );
        this.sinpeService.guardarOperaciones(this.operacionesEncontradas);

        this.cdRef.detectChanges();
      },
      () => {
        this.operacionesEncontradas = [];
        this.mensajeError = 'Error al consultar pagos. Intente más tarde';
      }
    );
  }

  cancelar(): void {
    this.sinpeService.emitirTotalPagar('0');
    this.sinpeService.resetearEstado()
    this.close();
  }

  aceptar() {
    this.sinpeService.guardarValoresForm(this.sinpeForm.value);
    this.sinpeService.emitirTotalPagar(
      this.totalPagarFormateado,
      this.sinpesSeleccionados
    );

    this.close();
  }

  get botonAceptarDeshabilitado(): boolean {
    return (
      this.sinpesSeleccionados.length === 0 ||
      (this.data !== null && this.totalPagar < this.data)
    );
  }
}
